import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fangdajing",
  "use": "icon-fangdajing-usage",
  "viewBox": "0 0 15.999 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.999 16\" id=\"icon-fangdajing\">\r\n  <path id=\"icon-fangdajing_路径_2710\" data-name=\"路径 2710\" d=\"M12.477,11.323a7,7,0,1,0-1.088,1.089l3.535,3.538,1.088-1.089Zm-1.9-.778a5.056,5.056,0,1,1,0-7.154A5.037,5.037,0,0,1,10.573,10.545Z\" transform=\"translate(-0.012 0.05)\" fill=\"#dbdbdb\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol